// B5's screens, registered the way every lane registers its own (lane contract C-29), so each renders in MissionShell's
// content slot inside its one McRoot: the Coordinator Workbench (#workbench, #workbench/<sr_…>, ?type=&status=&risk=…)
// behind `scheduling.workbench`, and the Final Interview Loop page (#requisitions/<R>/candidates/<aid>/schedule), one
// sub-route of the V1 requisitions view, which carries its own seat rule (an unknown or unauthorised application is the
// canonical not-found). The round, intake-call and debrief scheduling cards stay `.mc` islands on their V1 pages.

import { createElement } from "react";
import { registerView, type ViewProps } from "@/shell/viewRegistry";
import { WorkbenchPage } from "@/views/Workbench";
import { LoopSchedule } from "@/views/scheduling/LoopSchedule";

/** `requisitions/<R>/candidates/<aid>/schedule` exactly: nothing after `schedule`, never another candidate route. */
export const LOOP_SCHEDULE = /^requisitions\/(R-\d+)\/candidates\/([^/]+)\/schedule$/;

function LoopScheduleRoute({ route }: ViewProps) {
  const [, rid = "", aid = ""] = LOOP_SCHEDULE.exec([route.view, ...route.parts].join("/")) ?? [];
  return createElement(LoopSchedule, { key: `${rid}/${aid}`, rid, aid });
}

registerView("workbench", function WorkbenchRoute(_: ViewProps) { return createElement(WorkbenchPage); }, {
  lane: "B5", gates: ["scheduling.workbench"],
});
// above a lane's whole-candidate pattern (B3's profile routes), so the loop page is B5's whoever registers first
registerView(LOOP_SCHEDULE, LoopScheduleRoute, { lane: "B5", specificity: 3 });
